import { useContext } from "react";
import { paginationContext } from "../context";

export const usePaginationContext = () => useContext(paginationContext);
